// @ts-nocheck
"use client";
import React, { useEffect, useRef, useState } from "react";
import { cloneDeep } from "lodash-es";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Form, Input, Button, Upload, message, Radio } from "antd";
import type { UploadProps } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { touristUploadFile } from "@/lib/api/media"; // 确保这个路径是正确的
import { useSessionStore } from "@/lib/store/session";
import { sendForm } from "@/lib/api/form";
import { useTranslations } from "next-intl";
import FAQ from "@/components/Faqs/FaqCard";
import { useCategory } from "@/context/CategoriesContext";
import { defaultLocale } from "@/config";
import { Link, useRouter } from "@/navigation.ts";
import GetQuteTip from "@/components/Service/CNC/GetQuteTip.tsx";
import { formatFileSizeToUnit } from "@/lib/utils/util.ts";
import CaptchaComponent from "@/components/Captcha/page.tsx";
import { useFormCaptcha } from "@/components/Captcha/useFormCaptcha";
import { get_inquiry_blocking_keyword } from "@/lib/api/common.ts";

const { TextArea } = Input;
const MAX_INQUIRY_UPLOAD_FILE_COUNT = 9;

const ContactForm = ({
	title,
	titleContent,
	faqList,
	className,
	locale,
	innerClassName,
	dsc,
	tip,
	/** 为 true 时「上传文件」必选（默认必填） */
	uploadRequired = true,
}: {
	title?: string;
	titleContent?: string;
	faqList?: any[];
	className?: string;
	locale: string;
	innerClassName?: string;
	dsc?: string;
	tip?: string;
	uploadRequired?: boolean;
}) => {
	const router = useRouter();
	const [fileUploadResult, setFileUploadResult] = useState("[]");
	const { session_uuid } = useSessionStore();
	const [form] = Form.useForm();
	const uploadBatchQueueRef = useRef<Parameters<NonNullable<UploadProps["customRequest"]>>[0][]>([]);
	const uploadBatchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	useEffect(
		() => () => {
			if (uploadBatchTimerRef.current !== null) clearTimeout(uploadBatchTimerRef.current);
			uploadBatchQueueRef.current = [];
		},
		[],
	);
	const {
		captchaRef,
		captchaRequestId,
		handleCaptchaToken,
		handleCaptchaFailure,
		isSubmitting,
		isCaptchaVisible,
		canRequestSubmission,
		requestSubmissionToken,
		finishSubmission,
		runUpload,
	} = useFormCaptcha();

	const getBlockKeys = async () => {
		try {
			return await get_inquiry_blocking_keyword();
		} catch (e) {
			console.log(e);
			return { content_blocking_keyword_list: [], email_blocking_keyword_list: [] };
		}
	};

	const onFinish = async (formValues: any) => {
		const values = cloneDeep(formValues);
		const uploadedFiles = values.upload || [];
		if (uploadedFiles.some((file: { status?: string }) => file.status !== "done")) {
			message.warning(
				t(
					uploadedFiles.some((file: { status?: string }) => file.status === "error")
						? "form.fileUploadFail"
						: "form.pleaseWaitUpload",
				),
			);
			return;
		}
		const currentCaptchaToken = await requestSubmissionToken(async () => {
			// 关键词和邮箱屏蔽
			const blockObj: { content_blocking_keyword_list: string[]; email_blocking_keyword_list: string[] } =
				await getBlockKeys();
			const { content_blocking_keyword_list, email_blocking_keyword_list } = blockObj;
			let contentValid = true;
			// 内容
			content_blocking_keyword_list.forEach((key: string) => {
				if (values.message?.includes(key)) {
					contentValid = false;
					return;
				}
			});
			// 邮箱
			email_blocking_keyword_list.forEach((email: string) => {
				if (values.email.includes(email)) {
					contentValid = false;
					return;
				}
			});
			if (!contentValid) {
				message.error(t("form.inquiryContentBlocked"));
				return false;
			}
			return true;
		});
		if (!currentCaptchaToken) return;
		try {
			// 设备
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			const resIp = await fetch("/api/website/get-ip").then((res) => res.json());
			const sendObj = { source: "contact-us", type: 0, chart: "" };
			const inquiry_info: any = {
				form: [],
				contact_method: values.email && values.mobile ? 3 : 1,
				products: [],
				html: `<h1>您的网站 <a href="${process.env.NEXT_PUBLIC_SITE_URL}" target="_blank">${process.env.NEXT_PUBLIC_SITE_URL}</a> 有新询盘，请前往网站后台查看详细内容！</h1>
              <h2>询盘信息</h2>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">来源：${window.location.href}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">设备信息：${userAgent}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">Ip地址：${resIp.ip}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">名字：${values.name}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">公司：${values.company}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">邮箱：<a href='mailto:${values.email}' target="_blank"> ${values.email}</a></p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">手机号：<a href='https://wa.me/${values.mobile}' target="_blank"> ${values.mobile}</a></p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">服务类型：${values.service}</p>
              <p style="padding: 5px 10px;border:1px solid #ccc;border-radius: 10px;margin: 10px;">留言：${values.message}</p>
              `,
			};
			inquiry_info.form = [
				{ label: "Source", type: "input", value: window.location.href },
				{ label: "Device", type: "input", value: userAgent },
				{ label: "IP", type: "input", value: resIp.ip },
			];
			inquiry_info["Source"] = window.location.href;
			inquiry_info["Device"] = userAgent;
			inquiry_info["IP"] = resIp.ip;

			Object.keys(values).forEach((key) => {
				if (key === "message") {
					inquiry_info.form.push({ label: key, type: "textarea", value: values[key] });
					inquiry_info[key] = values[key];
				} else if (key === "Upload" || key === "upload") {
					if (values[key] && values[key].length > 0) {
						inquiry_info.html += `<h3>客户上传文件</h3>
                              <div style="display: flex;align-items: center;flex-wrap: wrap;width: 100%;">`;

						const list: any[] = [];
						values[key].forEach((item: any) => {
							const fileRet = getUploadedFileRecord(item);
							list.push({
								file_id: fileRet[item.name],
								file_size: item.size,
								file_type: item.type,
								file_name: item.name,
							});
							// 通知邮箱文件链接拼接
							if (fileRet.image_url) {
								inquiry_info.html += ` <a href="${fileRet.image_url}" style="cursor: pointer; padding: 0 10px;display: flex;"> `;
							} else {
								inquiry_info.html += ` <a href="${
									process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL
								}/medias/file_download/${
									fileRet[item.name]
								}" style="cursor: pointer; padding: 0 10px;display: flex;"> `;
							}
							inquiry_info.html += ` <div style="width:100%; background-color: #eff0f1;height: 100%;padding: 10px;border-radius: 5px; display: flex; align-items: center;">
            <div  style="position: relative; width: 30px; height: 40px; background-color: #5f5d5d; border-radius: 4px; box-shadow: 0 2px 5px #989a9b;">
                <div style="position: absolute; top: 0; right: 0; width: 10px; height: 10px; background-color: #e5e5e5; clip-path: polygon(0 0, 100% 0, 100% 100%);">
                </div>
            </div>
            <div style="display: flex;flex-direction: column;    margin-left: 10px; ">
                <span style="font-size: 14px;
                margin-bottom: 5px;">${item.name}</span>
                <span style=" font-size: 13px;
                color: #757D7D;">${formatFileSizeToUnit(item.size)}</span>
            </div>
        </div>
    </a>`;
						});
						inquiry_info.html += `</div>`;
						inquiry_info["files"] = list;
						inquiry_info.form.push({ label: key, type: "files", value: list });
					}
				} else {
					inquiry_info.form.push({ label: key, type: "input", value: values[key] });
					inquiry_info[key] = values[key];
				}
			});
			sendObj.chart = JSON.stringify({ inquiry_info });

			const response = await sendForm(sendObj, currentCaptchaToken);
			if (response && response.code === 200) {
				void message.success(t("form.sendSuccess"));
				router.push(`/thank-you?e=${values.email}&p=${values.mobile}`);
			} else {
				void message.error(response?.message || t("form.sendFail"));
			}
		} catch (error) {
			console.log(error);
			message.error(t("form.sendFail"));
		} finally {
			finishSubmission();
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.error("Failed:", errorInfo);
		message.error(t("Error.inqFillTip"));
	};

	const getUploadedFileRecord = (file: any) => {
		const fileRecords = file?.response?.detail?.file_ret || [];
		return (
			fileRecords.find((record: Record<string, unknown>) =>
				Object.prototype.hasOwnProperty.call(record, file.name),
			) || {}
		);
	};

	const getFileUploadResult = (fileList: any[] = []) => {
		return JSON.stringify(
			fileList
				.map((item: any) => {
					const fileRet = getUploadedFileRecord(item);
					const fileId = fileRet?.[item.name];
					const fileUrl = fileRet?.image_url
						? fileRet.image_url
						: fileId
							? `${process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL}/medias/file_download/${fileId}`
							: "";

					return fileUrl
						? {
								fileUrl,
								fileName: item.name,
								fileSuffix: item.name?.split(".").pop() || "",
							}
						: null;
				})
				.filter(Boolean),
		);
	};

	const normFile = (e: any) => {
		const fileList = Array.isArray(e) ? e : e?.fileList || [];
		setFileUploadResult(getFileUploadResult(fileList));
		return fileList;
	};

	const scheduleUploadBatch = () => {
		if (uploadBatchTimerRef.current !== null) return;
		// Collect Ant Design's per-file callbacks into one multipart request.
		uploadBatchTimerRef.current = setTimeout(() => {
			uploadBatchTimerRef.current = null;
			void uploadPendingFiles();
		}, 0);
	};

	const uploadPendingFiles = async () => {
		const currentBatch = uploadBatchQueueRef.current.splice(0, MAX_INQUIRY_UPLOAD_FILE_COUNT);
		if (currentBatch.length === 0) return;

		try {
			await runUpload(async () => {
				const response = await touristUploadFile({
					upload_list: currentBatch.map(({ file }) => file as File),
					session_uuid,
				});
				if (!response || response.code !== 200) {
					throw new Error(t("form.fileUploadFail"));
				}
				const fileRecords = currentBatch.map(({ file }) => {
					const fileRecord = getUploadedFileRecord({ name: (file as File).name, response });
					if (!fileRecord[(file as File).name]) {
						throw new Error(t("form.fileUploadFail"));
					}
					return fileRecord;
				});
				currentBatch.forEach(({ onSuccess }, fileIndex) => {
					onSuccess?.({ ...response, detail: { ...response.detail, file_ret: [fileRecords[fileIndex]] } });
				});
			});
			message.success(t("form.fileUploadSuccess"));
		} catch (error) {
			message.error(t("form.fileUploadFail"));
			currentBatch.forEach(({ onError }) => onError?.(new Error(t("form.fileUploadFail"))));
		} finally {
			if (uploadBatchQueueRef.current.length > 0) scheduleUploadBatch();
		}
	};

	const handleUpload: UploadProps["customRequest"] = (options) => {
		uploadBatchQueueRef.current.push(options);
		scheduleUploadBatch();
		return {
			abort: () => {
				uploadBatchQueueRef.current = uploadBatchQueueRef.current.filter((request) => request !== options);
			},
		};
	};

	const t = useTranslations();
	const { categories } = useCategory();

	return (
		<div className={`py-10 ${className}`}>
			<div
				className={`animate__animated animate__fadeIn container flex w-full gap-x-5 rounded-xl bg-white shadow max-md:flex-col ${innerClassName}`}
			>
				<div className="w-full overflow-y-auto rounded-lg bg-white p-8">
					<div className={`mb-8 ${title ? "text-left" : "text-center"} `}>
						<h2 className="text-4xl font-bold max-md:text-2xl">{title || t("menu.contactUs")}</h2>
						<p className="mt-4 text-sm text-gray-500 max-md:text-xs">{titleContent || t("home.inquiry1")}</p>
						{!titleContent && <p className="text-sm text-gray-500 max-md:text-xs">{t("home.inquiry2")}</p>}
					</div>
					<Form
						type="contentDocument"
						form={form}
						layout="vertical"
						validateTrigger={[]}
						noValidate
						disabled={isSubmitting}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						initialValues={{ remember: true, variant: "filled" }}
					>
						<div className="grid grid-cols-1 gap-6 max-md:gap-0 md:grid-cols-2">
							<Form.Item name="name" label={t("form.name")} className="capitalize">
								<Input placeholder={t("form.nameTip")} className="!rounded-sm p-2" />
							</Form.Item>
							<Form.Item
								name="company"
								label={t("form.company")}
								// rules={[{ required: true, message: t("form.pleaseCompany") }]}
								className="capitalize"
							>
								<Input placeholder={t("form.companyTip")} className="!rounded-sm p-2" />
							</Form.Item>
						</div>
						<div className="grid grid-cols-1 gap-6 md:grid-cols-2">
							<Form.Item
								name={"email"}
								label={t("form.email")}
								rules={[
									{ required: true, message: t("form.pleaseEmail") },
									{ type: "email", message: t("form.vailEmailTip") },
								]}
								className="capitalize"
							>
								<Input type="email" placeholder={t("form.emailTip")} />
							</Form.Item>
							<Form.Item name="mobile" label={t("form.phone")} className="capitalize">
								<PhoneInput
									disabled={isSubmitting}
									disableDropdown={isSubmitting}
									inputProps={{
										name: t("form.phone"),
									}}
									country={"us"}
									enableSearch
									inputStyle={{
										width: "100%",
										borderRadius: "0.375rem",
										borderColor: "#d1d5db",
									}}
									buttonStyle={{
										borderRadius: "0.375rem 0 0 0.375rem",
										borderColor: "#d1d5db",
									}}
								/>
							</Form.Item>
						</div>
						<Form.Item name="Service" label={t("menu.service")} className="capitalize">
							<Radio.Group
								name="Service"
								disabled={isSubmitting}
								className="!grid !grid-cols-3 gap-2 max-md:!grid-cols-1"
							>
								{categories?.edges.map((cate) => {
									return (
										cate.node.slug !== "Solution" && (
											<Radio value={cate.node.name} key={cate.node.id}>
												{" "}
												{locale === defaultLocale
													? cate.node.name
													: cate.node.translation
														? cate.node.translation.name
														: cate.node.name}{" "}
											</Radio>
										)
									);
								})}
								<Radio value="Others"> {t("base.Others")} </Radio>
							</Radio.Group>
						</Form.Item>
						<Form.Item name="message" label={t("form.message")} className="capitalize">
							<TextArea rows={4} placeholder={t("form.messageTip")} />
						</Form.Item>

						<Form.Item
							name="upload"
							label={t("form.upload")}
							valuePropName="fileList"
							getValueFromEvent={normFile}
							extra={
								t("form.support") +
								": jpg, pdf, png, bmp, doc, zip, rar, dwg, xlsx, excel, x_t, igs, step, stl, glb, gltf"
							}
						>
							<Upload.Dragger
								name="files"
								multiple
								maxCount={MAX_INQUIRY_UPLOAD_FILE_COUNT}
								beforeUpload={(file, selectedFiles) => {
									const existingFileCount = (form.getFieldValue("upload") || []).length;
									return existingFileCount + selectedFiles.indexOf(file) < MAX_INQUIRY_UPLOAD_FILE_COUNT
										? true
										: Upload.LIST_IGNORE;
								}}
								customRequest={handleUpload}
								listType="picture"
								disabled={isSubmitting}
							>
								<p className="ant-upload-drag-icon">
									<InboxOutlined />
								</p>
								<p className="ant-upload-text">{t("form.uploadTip")}</p>
								<p className="ant-upload-hint">{t("form.uploadTip1")}</p>
								<p className="text-gray-400">{t("inqName.fileSize")}: ≤15MB </p>
							</Upload.Dragger>
						</Form.Item>
						<input
							id="fileUploadResult"
							name="fileUploadResult"
							readOnly
							tabIndex={-1}
							value={fileUploadResult}
							style={{
								position: "absolute",
								width: 0,
								height: 0,
								padding: 0,
								border: 0,
								overflow: "hidden",
								visibility: "hidden",
							}}
						/>

						{isCaptchaVisible && (
							<Form.Item>
								<CaptchaComponent
									key={captchaRequestId}
									ref={captchaRef}
									action="chart"
									onTokenChange={handleCaptchaToken}
									onVerificationFailed={handleCaptchaFailure}
								/>
							</Form.Item>
						)}
						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								className="mt-4 w-full !rounded !py-4"
								loading={isSubmitting}
								disabled={!canRequestSubmission}
							>
								{t("base.Submit")}
							</Button>
						</Form.Item>

						<div className="mt-3 text-center text-sm text-gray-500">
							{t("base.JS Precision has industry-leading IP protection")}
						</div>
						<div className="mt-3 text-center text-sm text-gray-500">
							{t("base.By getting a quote I agree to JS Precision's")}{" "}
							<Link
								href="/policy"
								target="_blank"
								rel="noopener noreferrer"
								className="text-blue-600 underline hover:text-blue-800"
							>
								{t("base.privacyPolicy")}
							</Link>
						</div>
					</Form>
				</div>
				{faqList && (
					<div className="container mx-auto h-full px-4 md:px-0">
						{dsc && <p className="-pb-10">{t(dsc)}</p>}
						<FAQ faqData={faqList}></FAQ>
					</div>
				)}
			</div>
			{tip && <GetQuteTip tip={t(tip)}></GetQuteTip>}
		</div>
	);
};

export default ContactForm;
